import { newVector, Size } from '@lessonup/pins-shared';
import React from 'react';

export interface TriangleShapeProps {
  size: Size;
  strokeWidth: number;
}

export const TriangleShape: React.FC<TriangleShapeProps> = ({ size, strokeWidth }) => {
  const offset = strokeWidth / 2;
  const a = newVector(size.width / 2, offset);
  const b = newVector(size.width - offset, size.height - offset);
  const c = newVector(strokeWidth - offset, size.height - offset);
  const points = `${a.x},${a.y} ${b.x},${b.y} ${c.x},${c.y}`;

  return <polygon points={points} />;
};
